/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostEnvironmentReleasePlanPathParams = NonNullable<
  operations['PostEnvironmentReleasePlan']['parameters']['path']
>;

export type PostEnvironmentReleasePlanRequestBody = OperationRequestBodyContent<
  operations['PostEnvironmentReleasePlan']
>;

export interface Input extends PostEnvironmentReleasePlanPathParams {
  apiVersion?: string;
  body: PostEnvironmentReleasePlanRequestBody;
  header: NonNullable<operations['PostEnvironmentReleasePlan']['parameters']['header']>;
}

export async function PostEnvironmentReleasePlan(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/release-plans', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
